import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "../components/flexproducts";
import Header from "../headers_footer/header";

const Haircolor = () => {

return (

<div>

<Navbar />
<Flexproducts type="haircolor" />
<Header></Header>

</div>

);
};

export default Haircolor;